import React from 'react'

const Magnifier = ({ width = 18.032, height = 18.032 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 18.032 18.032"
  >
    <path
      fill="#454e5b"
      d="M9.75,6h-6V4.5h6Zm0,3h-6V7.5h6Zm6.129,9-5.54-5.54a6.766,6.766,0,1,1,2.121-2.121L18,15.879ZM6.75,12A5.25,5.25,0,1,0,1.5,6.75,5.25,5.25,0,0,0,6.75,12Z"
      transform="translate(0.032 0.032)"
    />
  </svg>
)

export default Magnifier
